import { fontSize } from '@mui/system';
import React from 'react';

function Header({ reportData }) {
  // Extract values with fallbacks matching the sample image
  const dateAndTime = reportData?.reporteDate || '16/04/2026 (15:11:50)';
  const controlNumber = reportData?.controlNumber || '10852865760';


  return (
    <header style={styles.headerContainer}>

      {/* Right Content Area (TransUnion CIBIL Logo) */}
      <div style={styles.logoSection}>
        <img
          src='/tu_cibil.png'
          alt="TransUnion CIBIL Logo"
          style={styles.logoImage}
        />
      </div>
    </header>
  );
}

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    padding: '0px 10px 12px',
    backgroundColor: '#ffffff',
fontFamily: '"Times New Roman", Times, Georgia, serif',
    boxSizing: 'border-box',
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: '24px',
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '28px',
    marginBottom: '8px',
  },
  dataBlock: {
    display: 'flex',
    alignItems: 'end',
    fontSize: '13px',
    letterSpacing: '0.3px',
  },
  label: {
    fontSize: '10px',
    color: '#00a1de', // Exact CIBIL Cyan Blue
    fontWeight: '600',
    textTransform: 'uppercase',
    marginRight: '4px',
  },
  value: {
        fontSize: '11px',

    color: '#000000',
    fontWeight: '700',
  },
  divider: {
    color: '#333333',
    fontWeight: '300',
    fontSize: '18px',
    lineHeight: '1',
    userSelect: 'none',
  },
  yellowBar: {
    height: '4px',
    backgroundColor: '#ffc20e', // CIBIL Accent Yellow
    width: '100%',
  },
  logoSection: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  logoImage: {
    height: '44px',
    width: 'auto',
    objectFit: 'contain',
  },
};

export default Header;